module.exports = __webpack_public_path__ + "img/PurchaseNewLicenseLink.56d5743a.jpg";